import { ReactNode } from 'react';

export function HintBox({ children }: { children: ReactNode }) {
  return (
    <div
      className="flex flex__dir--row p-left-m p-right-m p-top-l p-bottom-l m-bottom-xxl m-left-4xl m-right-4xl border-color-blue-500 bg-blue-50 border-solid border-radius-xl"
      style={{ borderWidth: '1px' }}
    >
      {children}
    </div>
  );
}
